export default "__VITE_ASSET__BJ53RO_p__"